// src/Components/Footer.js
import React, { useState, useEffect } from 'react';
import LegalModal from './LegalModal';

export default function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

  useEffect(() => {
    // Listen for openLegal events from other components
    const handleOpenLegal = (e) => {
      setSelectedDoc(e.detail);
      setModalOpen(true);
    };

    window.addEventListener('openLegal', handleOpenLegal);
    return () => window.removeEventListener('openLegal', handleOpenLegal);
  }, []);

  const openModal = (docType) => {
    setSelectedDoc(docType);
    setModalOpen(true);
  };

  const linkStyle = {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '10px',
    color: 'rgba(0,0,0,0.35)',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
  };

  return (
    <>
      <div
        className="absolute bottom-0 left-0 right-0 z-30 pointer-events-none"
        style={{ fontFamily: "'DM Sans', sans-serif" }}
      >
        <div
          className="pb-2 pt-1 px-4"
          style={{ backgroundColor: 'transparent' }}
        >
          <div
            className="pointer-events-auto"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '0 8px',
              textShadow: '0 1px 2px rgba(255,255,255,0.8)',
            }}
          >
            <button
              onClick={() => openModal('privacy')}
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'rgba(0,0,0,0.6)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(0,0,0,0.35)')}
            >
              Privacy Policy
            </button>
            <span style={{ fontSize: '10px', color: 'rgba(0,0,0,0.25)' }}>·</span>
            <button
              onClick={() => openModal('terms')}
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'rgba(0,0,0,0.6)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(0,0,0,0.35)')}
            >
              Terms of Service
            </button>
            <span style={{ fontSize: '10px', color: 'rgba(0,0,0,0.25)' }}>·</span>
            <button
              onClick={() => openModal('refund')}
              style={linkStyle}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'rgba(0,0,0,0.6)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(0,0,0,0.35)')}
            >
              Refund Policy
            </button>
            <span style={{ fontSize: '10px', color: 'rgba(0,0,0,0.25)' }}>·</span>
            <a
              href="mailto:hypacharge@gmail.com"
              style={{ ...linkStyle, textDecoration: 'underline' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'rgba(0,0,0,0.6)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(0,0,0,0.35)')}
            >
              Contact
            </a>
            <span style={{ fontSize: '10px', color: 'rgba(0,0,0,0.25)' }}>·</span>
            <span
              style={{
                fontSize: '10px',
                color: 'rgba(0,0,0,0.35)',
                textShadow: '0 1px 2px rgba(255,255,255,0.8)',
              }}
            >
              © {new Date().getFullYear()} SIA Flight Tracker. Not affiliated with Singapore Airlines.
            </span>
          </div>
        </div>
      </div>

      <LegalModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        docType={selectedDoc}
      />
    </>
  );
}
